// components/Heading.jsx
import { Box, Typography } from "@mui/material";

const DashaTitle = ({
  children,
  level = "body",
  color = "text-indigo-600",
  className = "",
  ...props
}) => {
  return (
    <Box className="my-2">
    <Typography
      variant={level}
      className={`${color} font-semibold ${className}`}
      {...props}
    >
      {children}
    </Typography>
    </Box>
  );
};

export default DashaTitle;
